module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "index": "2",
      "showbar": "true"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('product3.name')) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "banner banner1"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_text'))
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title banner_title1",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_text1'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center button_banner",
    staticStyle: {
      "position": "absolute",
      "top": "4.32rem",
      "width": "100%"
    }
  }, [_c('a', {
    staticClass: "button_default",
    attrs: {
      "href": "https://master.vrviu.com/index.html"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.banner_botton'))
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item"
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.introduction_title'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "height": "3.86rem",
      "width": "6.85rem",
      "margin": "0 auto",
      "margin-top": "0.41rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "height": "3.86rem",
      "width": "6.85rem",
      "margin": "0 auto",
      "margin-top": "0.41rem"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center clearfix",
    staticStyle: {
      "background": "#f4f9ff",
      "margin-top": "0.7rem",
      "margin-bottom": "-0.9rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "padding-top": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.introduction_title2'))
    }
  }), _vm._v(" "), _c('ul', {
    staticStyle: {
      "position": "relative",
      "z-index": "1"
    }
  }, [_c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic1')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic11'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic12')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic2')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic21'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic22')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic3')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic31'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic32')) + "\n            ")])])]), _vm._v(" "), _c('li', {
    staticClass: "why_content clearfix"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "fl",
    staticStyle: {
      "margin-left": "0.6rem"
    }
  }, [_c('h4', {
    staticClass: "why_title"
  }, [_vm._v(_vm._s(_vm.$t('product3.platform_pic4')))]), _vm._v(" "), _c('div', {
    staticClass: "why_text"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic41'))), _c('br'), _vm._v("\n              " + _vm._s(_vm.$t('product3.platform_pic42')) + "\n            ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[8]),
      expression: "imglist[8]",
      arg: "background-image"
    }],
    staticClass: "content_bg",
    staticStyle: {
      "background-color": "rgba(244, 249, 255,1)"
    }
  }, [_c('div', {
    staticClass: "content_footer"
  }, [_c('h3', {
    staticClass: "content_item_title white",
    staticStyle: {
      "margin-bottom": "0.4rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text25'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text content_item_text1 white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text26'))
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "content_item_text white",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text29'))
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "button_default",
    staticStyle: {
      "margin-top": "0.7rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('product3.text27'))
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  })])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon1"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon2"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('span', {
    staticClass: "why_icon why_icon3"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-97fda7d2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/product.vue
// module id = 100
// module chunks = 0